import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.small";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.small";

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Fragment } from 'react';
import styled from 'styled-components';
import { spacing, color, typography } from '../../style/theme';
var SearchResultWrapper = styled.div.withConfig({
  displayName: "SearchResult__SearchResultWrapper",
  componentId: "gu3h49-0"
})(["display:flex;align-items:center;border-bottom:1px solid #ddd;cursor:", ";&:last-child{border-bottom:0;}.matchTerm{color:", ";}"], function (props) {
  return props.searchResultClick ? 'pointer' : 'default';
}, color.primaryBlue);
var SearchResultIcon = styled.div.withConfig({
  displayName: "SearchResult__SearchResultIcon",
  componentId: "gu3h49-1"
})(["flex-grow:0;flex-shrink:1;flex-basis:30px;min-width:30px;min-height:30px;margin-top:", "px;margin-right:", "px;margin-bottom:", "px;margin-left:0;", ":hover &{min-width:", ";margin-right:", ";}"], spacing.base / 2, spacing.base / 2, spacing.base / 2, SearchResultWrapper, function (props) {
  return props.searchResultClick ? '36px' : '30px';
}, function (props) {
  return props.searchResultClick ? spacing.base / 2 - 6 + "px" : spacing.base / 2 + "px";
});
var SearchResultName = styled.div.withConfig({
  displayName: "SearchResult__SearchResultName",
  componentId: "gu3h49-2"
})(["flex-grow:1;flex-shrink:1;flex-basis:auto;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;", ":hover &{font-weight:", ";& strong{font-weight:", ";}}"], spacing.base / 2, spacing.base / 2, spacing.base / 2, SearchResultWrapper, function (props) {
  return props.searchResultClick ? 500 : 400;
}, function (props) {
  return props.searchResultClick ? 600 : 500;
});
var SearchResultAction = styled.div.withConfig({
  displayName: "SearchResult__SearchResultAction",
  componentId: "gu3h49-3"
})(["flex-grow:0;flex-shrink:1;flex-basis:auto;"]);
var SearchResultBtn = styled.a.withConfig({
  displayName: "SearchResult__SearchResultBtn",
  componentId: "gu3h49-4"
})(["display:inline-block white-space:nowrap;font-size:1.3rem;background-color:#fff;border:1px solid #ddd;padding:2px 5px;text-transform:uppercase;text-decoration:none;color:#000;font-weight:500;cursor:pointer;&:hover,&:active,&:focus{background-color:#ddd;}"]);
var ProductNameText = styled.p.withConfig({
  displayName: "SearchResult__ProductNameText",
  componentId: "gu3h49-5"
})(["margin-bottom:0;font-size:", "rem;"], typography.small);

var SearchResult =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SearchResult, _React$Component);

  function SearchResult() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "getImageResizeUrl", function (url) {
      return url.replace('s3-eu-west-1.amazonaws.com/pt-manufacturers-products', 'manufacturers-products-images.papertrail.io/50x50');
    });

    _defineProperty(_assertThisInitialized(_this), "searchResultBtnClick", function (e) {
      // Prevent the button click from triggering parent click handler
      e.stopPropagation();
      e.preventDefault();

      _this.props.onSearchResultBtnClick(_this.props.product);
    });

    return _this;
  }

  var _proto = SearchResult.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        product = _this$props.product,
        searchResultClick = _this$props.searchResultClick,
        searchResultBtnText = _this$props.searchResultBtnText;
    return React.createElement(SearchResultWrapper, {
      onClick: function onClick() {
        return searchResultClick && searchResultClick(product);
      },
      searchResultClick: searchResultClick
    }, React.createElement(SearchResultIcon, {
      searchResultClick: searchResultClick
    }, product.images[0] && React.createElement("img", {
      src: this.getImageResizeUrl(product.images[0]),
      alt: product.name
    })), React.createElement(SearchResultName, {
      searchResultClick: searchResultClick
    }, product.manufacturer && React.createElement("span", null, React.createElement("small", {
      dangerouslySetInnerHTML: {
        __html: product.manufacturerHtml || product.manufacturer
      }
    })), React.createElement(ProductNameText, {
      dangerouslySetInnerHTML: {
        __html: product.nameHtml || product.name
      }
    }), React.createElement("div", null, product.matches.data.filter(function (match) {
      return match.html;
    }).map(function (match, index) {
      return React.createElement(Fragment, {
        key: index
      }, !!index && ', ', React.createElement("small", null, match.label, ":", ' ', React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: match.html
        }
      })));
    }))), searchResultBtnText && React.createElement(SearchResultAction, null, React.createElement(SearchResultBtn, {
      onClick: this.searchResultBtnClick
    }, searchResultBtnText)));
  };

  return SearchResult;
}(React.Component);

export default SearchResult;